<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-crediblue-100 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center justify-center">
            <div
                class="w-44 h-14 md:w-52 md:h-16 rounded-full overflow-hidden border border-white/10 shadow-md flex items-center justify-center transition-transform duration-200 hover:scale-105 p-0 bg-transparent"
            >
                <img
                    class="max-w-[90%] max-h-[88%] object-contain"
                    src="images/logo/knox-security.svg"
                    alt="Logo image"
                />
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <div class="flex items-center space-x-2 pr-2">
            <!-- Un solo botón combinado -->
            <button
                mat-icon-button
                (click)="toggleNavigationAndAppearance('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </div>

        <!-- Componentes a la derecha -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <button class="lg:hidden" mat-icon-button>
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer (opcional) -->
    <!--
    <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium">
            Fuse &copy; {{ currentYear }}
        </span>
    </div>
    -->
</div>
